/**
 * TanStack Query hooks for `pre-landing`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	preLandingQueryKeys,
	type CreatePreLandingBody,
	type ListPreLandingResponse,
	type PreLandingRow,
} from "./api";

export function usePreLandingList(): UseQueryResult<ListPreLandingResponse, Error> {
	return useQuery({
		queryKey: preLandingQueryKeys.list(),
		queryFn: list,
	});
}

export function usePreLandingCreate(): UseMutationResult<PreLandingRow, Error, CreatePreLandingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: preLandingQueryKeys.all });
		},
	});
}

export function usePreLandingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: preLandingQueryKeys.all });
		},
	});
}
